import { useQuery } from '@tanstack/react-query'
import { useMemo } from 'react'
import { getGaussIframeUrl } from '../../../data/gauss'
import { UserFriendlyError } from '../../../model/Error'
import { gaussKeys } from './gauss.keys'

interface GetGaussIframeUrlParams {
  enabled: boolean
}

export const useGetGaussIframeUrl = ({ enabled }: GetGaussIframeUrlParams) => {
  const queryKey = useMemo(() => gaussKeys.iframeUrl(), [])

  return useQuery({
    queryKey,
    queryFn: async () => {
      const { data, ok } = await getGaussIframeUrl()

      if (!data || !ok) {
        throw new UserFriendlyError(
          'error',
          "Une erreur s'est produite",
          "Impossible d'accéder à Gauss",
        )
      }
      return data
    },
    staleTime: 0,
    gcTime: 0,
    refetchOnWindowFocus: false,
    enabled,
  })
}
